<ng-template #productName>
  <h3 class="box-product-name h4 m-0" [title]="product.name">
    @if (!product.isCustom) {
      <a tabindex="0" [routerLink]="{ cxRoute: 'product', params: product } | cxUrl">
        {{ fixProductName(product.name) }}
      </a>
    } @else {
      <span>
        {{ fixProductName(product.name) }}
      </span>
    }
  </h3>
</ng-template>

<ng-template #boxPrice>
  <div class="box-2">
    @if (!product.discontinued) {
      <div class="price" [attr.aria-label]="'productDetails.productPrice' | cxTranslate">
        <product-price [InProduct$]="productAsObservable()" [lazyPrice]="true"></product-price>
      </div>
    } @else {
      <span class="ff-bold m-t-20 text-danger">
        {{ 'productRow.noLonger' | cxTranslate }}
      </span>
    }
  </div>
</ng-template>

<ng-template #codes>
  <div class="box-codes">
    <p *ngIf="product.partNumber">
      <span class="attr"> {{ 'intro.part' | cxTranslate }} #: </span>
      <span class="value"> {{ product.partNumber }} </span>
    </p>

    <p *ngIf="product.catalogNumber">
      <span class="attr"> {{ 'productRow.labels.catalog' | cxTranslate }} #: </span>
      <span class="value"> {{ product.catalogNumber }} </span>
    </p>
  </div>
</ng-template>

<ng-container
  *ngIf="{
    isLogged: isLogged$ | async,
  } as content"
>
  <div #container class="container-product-item-compact simple-card d-flex">
    <div class="box-left m-r-12">
      <button class="btn-toggle-status" (click)="toggleBoxStatus()">
        <span class="material-symbols-outlined d-flex"> arrow_forward_ios </span>
      </button>

      <product-compare-check [InProduct]="product" label=""></product-compare-check>
    </div>

    <div class="box-right">
      <ng-container *ngTemplateOutlet="productName"> </ng-container>

      <div class="bottom-header compact-version">
        <div class="box-codes">
          <ng-container *ngTemplateOutlet="codes"> </ng-container>
        </div>

        <ng-container *ngTemplateOutlet="boxPrice"> </ng-container>

        <div class="actions">
          @if (content.isLogged && !product.discontinued) {
            <div class="add-to-cart-container">
              <cx-add-to-cart
                [inProduct$]="productAsObservable()"
                [showQuantity]="false"
                [qty$]="addToCartForm.get('quantity')?.valueChanges"
              >
              </cx-add-to-cart>
            </div>
          }
        </div>
      </div>

      <div class="content">
        <div class="box-1">
          <ng-container *ngTemplateOutlet="codes"> </ng-container>
        </div>

        <ng-container *ngTemplateOutlet="boxPrice"> </ng-container>
      </div>
    </div>

    <div class="container-full">
      <collapse-list [collapseList]="keyFeatures"></collapse-list>

      <div class="actions">
        <a tabindex="0" [routerLink]="{ cxRoute: 'product', params: product } | cxUrl" class="btn btn-primary w-100">
          <span class="d-flex icon material-symbols-outlined m-r-4"> frame_inspect </span>

          {{ 'productRow.actions.viewDetails' | cxTranslate }}
        </a>

        @if (product.discontinued) {
          <product-replacement [product]="product"></product-replacement>
        } @else {
          @if (content.isLogged) {
            <cx-add-to-cart
              [inProduct$]="productAsObservable()"
              [showQuantity]="false"
              [qty$]="addToCartForm.get('quantity')?.valueChanges"
            >
            </cx-add-to-cart>
          } @else {
            <a tabindex="0" [routerLink]="['/where-to-buy']" class="btn btn-primary w-100">
              <span class="d-flex icon material-symbols-outlined m-r-4"> location_on </span>

              {{ 'productRow.actions.whereToBuy' | cxTranslate }}
            </a>
          }
        }
      </div>
    </div>
  </div>
</ng-container>
